module.exports = __webpack_public_path__ + "static/assets/73296ec2283b6f1757ab235aef9b88db.svg";